import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';

@Injectable()
export class SubmittedFormsService {

    constructor(
        private _http: HttpClient,
        private _capEngineService: CapabilityEngineService
    ) { }

    getSubmittedForms() {
        let header = this._capEngineService.getHeaders('viewTaskList');
        return this._http.get(environment.serverUrl + '/tasks', header);
    }
    //  existing API
    // performPagination(pageNumber) {
    //     let header: any = this._capEngineService.getHeaders('viewTaskTemplateList');
    //     header.params = {
    //         category: 'inspection'
    //     };
    //     return this._http.get(environment.serverUrl + '/taskTemplate/task/pagination/' + pageNumber, header);
    // }

    // new API
    performPagination(pageNumber) {
        let header: any = this._capEngineService.getHeaders('viewTaskTemplateList');
        header.params = {
            category: 'all'
        };
        return this._http.get(environment.serverUrl + '/taskTemplate/pagination/' + pageNumber, header);
    }
    getTemplateDirecotries(){
        return this._http.get(environment.serverUrl + '/taskTemplate/directories' )
    }
    getRawData() {
        return this._http.get(environment.serverUrl + '/rawData/');
    }

}



// WEBPACK FOOTER //
// ./src/app/submitted-forms/submitted-forms.service.ts